export const checkQuotationCodes = (codes: string[], current_quotation: string | null) => {
    if(!current_quotation) return false;
    if(codes.includes(current_quotation) || window.location.href.includes('dev.facilitatrip.com') || window.location.href.includes('localhost')) return true;
    return false;
};